"use client";

import React from "react";

import { DetectedMobileAppDownloadBanner } from "@lattice/frontend/components/banners/mobile-app-download-banner";
import {
  registerSuperProperties,
  setUserProperties,
} from "@lattice/frontend/lib/analytics/mixpanel";
import type { T_AnalyticsProperties } from "@lattice/frontend/lib/analytics/types";
import { WorkspaceUserProvider } from "@lattice/frontend/lib/contexts/workspace-user-context";

function AnalyticsUserPropertiesSync({
  properties,
}: {
  properties?: T_AnalyticsProperties;
}) {
  React.useEffect(() => {
    if (!properties) return;
    setUserProperties(properties);
    registerSuperProperties(properties);
  }, [properties]);

  return null;
}

export function AuthenticatedAppLayoutClient({
  children,
  analyticsUserProperties,
  userFirstName,
}: React.PropsWithChildren<{
  analyticsUserProperties?: T_AnalyticsProperties;
  userFirstName: string | null;
}>) {
  return (
    <WorkspaceUserProvider firstName={userFirstName}>
      <div className="app-experience flex h-svh flex-col overflow-hidden">
        <AnalyticsUserPropertiesSync properties={analyticsUserProperties} />
        <DetectedMobileAppDownloadBanner />
        <div className="min-h-0 flex-1">{children}</div>
      </div>
    </WorkspaceUserProvider>
  );
}
